import { faCalendar } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@material-ui/core'
import { parse } from 'date-fns'
import { Link } from 'react-router-dom'

import { encodeSelectedSchools } from '../encode-availability-link'
import { API_DATE_FORMAT } from '../types'

export default function VisitAvailabilityLink({
  highSchool,
}: {
  highSchool: { id: string; name: string; nextVisitDate: string }
}) {
  return (
    <Link
      to={`${import.meta.env.BASE_URL}/recruit/visits/view/week?${encodeSelectedSchools(
        [{ id: highSchool.id, name: highSchool.name }],
        highSchool.nextVisitDate,
      )}`}
    >
      <Box
        mr={1}
        display="inline-block"
      >
        <FontAwesomeIcon icon={faCalendar} />
      </Box>
      {Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      }).format(parse(highSchool.nextVisitDate, API_DATE_FORMAT, new Date()))}
    </Link>
  )
}
